var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',[_c('Panel',{staticStyle:{"margin-bottom":"0px","display":"flex"},attrs:{"lineColor":"var(--primary-color)"}},[_c('h3',{staticClass:"text-uppercase my-5"},[_vm._v("Painel Administrativo")])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }